<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col class="mb-1">
          <router-link :to="{ name: 'EXCMCaseTypeList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-tabs>
              <b-tab :title="$t('views.excmcasetype.create.title')">
                <EXCMCaseTypeForm
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
              </b-tab>
              <b-tab :title="$t('views.excmcasetype.create.titleRoles')">
                <CreateRolesForCaseType></CreateRolesForCaseType>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMCaseTypeForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import CreateRolesForCaseType from '@/components/Dashboard/Views/excmcasetype/CreateRolesForCaseType'

const { mapGetters, mapActions } = createNamespacedHelpers('excmcasetype/create')

export default {
  components: {
    EXCMCaseTypeForm,
    Loader,
    CreateRolesForCaseType
  },
  data () {
    return {
      item: {
        emailEnable: 0,
        durationUnit: 1,
        customFields: [],
        caseParams: {
          hasNotes: true,
          hasCategorization: true,
          hasTimeline: true,
          hasTicket: true,
          hasClient: true,
          hasDevice: true,
          hasAgreement: true,
          hasSLA: true,
          hasPartner: true,
          hasPriority: false,
          hasGenre: false
        },
        keyTaskTypes: [],
        keyRoles: [],
        batchNumber: null
      }
    }
  },
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCaseTypeCreate')
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXCMCaseTypeUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
